import { useMemo } from "react";
import {
  useConnectionRegistry,
  useServiceFetch,
} from "../../../services/ConnectionRegistryProvider";
import { createMyQueueClient, type MyQueueClient } from "../services/myqueueApi";

export function useMyQueueClient(): MyQueueClient {
  const serviceFetch = useServiceFetch();
  const registry = useConnectionRegistry();
  const apiBaseUrl = registry.getConnection("myqueue")?.apiBaseUrl ?? "";
  return useMemo(
    () => createMyQueueClient(serviceFetch, apiBaseUrl),
    [serviceFetch, apiBaseUrl],
  );
}
